/**
 * Opens and refreshes the theme cart drawer after Loop bundle ATC.
 * Do not add this logic to loop_bundle.js (Loop-managed file).
 */
(function () {
  if (!window.location.pathname.includes('/a/loop_subscriptions/bundle')) return;

  const LOOP_DRAWER_CONTAINER = 'LOOP_pure-plant-demo_bundles_drawer';
  let isRefreshing = false;

  async function refreshAndOpenCartDrawer() {
    if (isRefreshing) return;
    isRefreshing = true;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      const cart = await fetch('/cart.js').then((response) => response.json());

      window.Loop = window.Loop || {};
      window.Loop.bundleCartAllItems = cart.items;

      const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then((response) =>
        response.json()
      );
      const parser = new DOMParser();

      if (sections['cart-icon-bubble']) {
        const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        document.querySelectorAll('.cart-count-bubble').forEach((element) => {
          const newBubble = bubbleDoc.querySelector('.cart-count-bubble');
          if (newBubble) element.innerHTML = newBubble.innerHTML;
        });
      }

      updateHeaderCartCount(cart);

      if (sections['cart-drawer']) {
        const drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = drawerDoc.querySelector('cart-drawer');
        if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
      }

      cartDrawer.classList.remove('is-empty');

      if (typeof initLoopBundle === 'function') {
        await initLoopBundle(LOOP_DRAWER_CONTAINER);
      }

      const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }

      cartDrawer.open();
    } catch (error) {
      console.error('Loop bundle cart drawer refresh failed:', error);
    } finally {
      isRefreshing = false;
    }
  }

  function updateHeaderCartCount(cart) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    let countWrapper = cartIcon.querySelector('.header-v2-cart-count');

    if (cart.item_count > 0) {
      if (!countWrapper) {
        countWrapper = document.createElement('div');
        countWrapper.className = 'header-v2-cart-count';
        cartIcon.appendChild(countWrapper);
      }
      countWrapper.innerHTML =
        cart.item_count < 100 ? `<span aria-hidden="true">${cart.item_count}</span>` : '';
    } else if (countWrapper) {
      countWrapper.remove();
    }
  }

  function shouldHandleCartAdd(url) {
    return typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'));
  }

  function scheduleRefresh() {
    window.clearTimeout(scheduleRefresh.timeoutId);
    scheduleRefresh.timeoutId = window.setTimeout(refreshAndOpenCartDrawer, 150);
  }

  let loopEventHandled = false;

  document.addEventListener('loop:afterAddBundleToCart', (event) => {
    if (event.detail?.success === false) return;
    loopEventHandled = true;
    scheduleRefresh();
    window.setTimeout(() => {
      loopEventHandled = false;
    }, 2000);
  });

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

    return originalFetch.apply(this, args).then((response) => {
      if (!loopEventHandled && shouldHandleCartAdd(url) && response.ok) {
        scheduleRefresh();
      }
      return response;
    });
  };
})();
